(function () {
  let tlYMALClone;
  Object.defineProperty(window, "tlYMAL", {
    configurable: true,
    get() { return tlYMALClone; },
    set(val) {
      if (!val || tlYMALClone) return;
      tlYMALClone = val;

      val.checkCartData = async () => {
        const isCartPage = window.location.pathname === "/cart";
        const cartData = await val.getCartAjax();
        if (!cartData && isCartPage) return null;

        const productInCart = new Set();
        const ruleIdMapAddedRecommendProd = new Map();
        (cartData?.items ?? []).forEach((item) => {
          const productId = String(item.product_id);
          const ruleId = item.properties?.[val.PROPERTY];
          if (ruleId) {
            const added = ruleIdMapAddedRecommendProd.get(ruleId) ?? [];
            ruleIdMapAddedRecommendProd.set(ruleId, [...added, productId]);
          }
          productInCart.add(productId);
        });

        // Ngoài trang cart: trigger theo sản phẩm đang xem (giữ logic custom cũ)
        const triggerProducts = isCartPage
          ? Array.from(productInCart)
          : (window.productId ? [String(window.productId)] : []);

        // Giữ tương thích với app version cũ (đọc từ instance)
        val.ruleIdMapAddedRecommendProd = new Map(ruleIdMapAddedRecommendProd);
        return { productInCart: triggerProducts, ruleIdMapAddedRecommendProd };
      };
    },
  });
})();
